/**
 * AuthContext — extracted from App.js to break circular imports.
 * AuthProvider remains in App.js; contexts import useAuth from here.
 */
import { createContext, useContext } from "react";

const AuthContext = createContext(null);
const useAuth = () => useContext(AuthContext);

export { AuthContext, useAuth };
